export const REFERENCE = "REFERENCE";
export const IDE = "IDE";
export const COLLECTION = "COLLECTION";
export const GUIDED = "GUIDED";
export const REF_EXAMPLE = "REF_EXAMPLE";